import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('TaxClassification?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('TaxClassification/show/'+id);
    },    
    create(params) {
        return Service().post('TaxClassification/create', params);
    },
    update(id, params) {
        return Service().post('TaxClassification/update/'+id, params);
    },
    delete(id) {
        return Service().post('TaxClassification/delete/'+id);
    }
}